const DEFAULT_ITEMS = [
  "Free shipping over ₹2,500",
  "Food-safe & lead-free glazes",
  "Easy 7-day returns",
  "Secure crushproof packaging",
  "New pieces added weekly",
  "Handmade in small batches",
];

const Marquee = ({ items }) => {
  const list = items && items.length ? items : DEFAULT_ITEMS;
  return (
    <div className="overflow-hidden border-y border-linen bg-sand py-3.5" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex items-center gap-10">
        {[...list, ...list, ...list, ...list].map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.25em] text-clay/70">
            {item}
            <span className="h-1 w-1 rounded-full bg-terra" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
